<div class="container my-3">
    <div class="row">
        <div class="col-md-8 offset-md-2 px-0 pt-0 pb-2">
            <button type="button" class="btn btn-text-gray btn-icon p-0" style="min-width: auto" (click)="cancelClicked()">
                <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use></svg>
                <span cvLocalizedText langSection="Common" langKey="Back_Button">Back</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-8 offset-md-2 content p-4">
            <div class="row mt-2">
                <div class="col">
                    <div class="font-size-18 lato-bold" cvLocalizedText langSection="Pipeline_Configuration" langKey="Properties">Properties</div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="checkShowInSelector" [(ngModel)]="model.showInSelector">&nbsp;
                        <label for="checkShowInSelector" class="form-check-label" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Visible_Selector">
                            Visible in Selector
                        </label>
                    </div>
                    <!--<div class="form-check">
                        <input type="checkbox" class="form-check-input" id="checkMarkAsKPI" [(ngModel)]="model.markAsKPI">&nbsp;
                        <label for="checkMarkAsKPI" class="form-check-label" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Mark_KPI">
                            Mark this metric as a KPI
                        </label>
                    </div>-->
                </div>
            </div>
            <!-- Metric Name and Metric Abbreviation-->
            <div class="row mt-3">
                <div class="col-5">
                    <label for="textMetricName" class="form-control-label body-2" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Full_Name">Full Metric Name</label><span title="Required" cvLocalizedAttrs="title" attrLangSection="Pipeline_Configuration" attrLangKey="Required" class="required body-2 color-redRyder">*</span>
                </div>
                <div class="col-3">
                    <label for="textMetricAbv" class="form-control-label body-2" cvLocalizedText langSection="Pipeline_Configuration" langKey="Abbreviation">Abbreviation</label><span title="Required" cvLocalizedAttrs="title" attrLangSection="Pipeline_Configuration" attrLangKey="Required" class="required body-2 color-redRyder">*</span>
                </div>
            </div>
            <div class="row">
                <div class="col-5">
                    <input type="text" id="textMetricName" class="form-control w-100" [(ngModel)]="model.metricName" required minlength="1" maxlength="50" />
                </div>
                <div class="col-3">
                    <input type="text" id="textMetricAbv" class="form-control w-100" [(ngModel)]="model.metricAbv" required minlength="1" maxlength="20" />
                </div>
            </div>
            <!-- Description -->
            <div class="row mt-4">
                <div class="col-8">
                    <label for="textDescription" class="body-2" cvLocalizedText langSection="Common" langKey="Description">Description</label>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <textarea id="textDescription" class="form-control" rows="3" [(ngModel)]="model.description"></textarea>
                </div>
            </div>
            <!-- Metric Levels -->
            <div class="row mt-4">
                <div class="col-5">
                    <label class="form-control-label body-2 mb-0" for="selectEmpLevelMin" cvLocalizedText langSection="Pipeline_Configuration" langKey="Employee_Hierarchy_Label">Employee Hierarchy</label><br/>
                    <div class="caption color-valyrianSteel" cvLocalizedText langSection="Pipeline_Configuration" langKey="Hierarchy_Hint">Select the lowest level this metric applies to.</div>
                </div>
            </div>
            <div class="row">
                <div class="col-5">
                    <select class="form-control" id="selectEmpLevelMin" [class]="{'color-valyrianSteel': model.empLevelMin == null}" [(ngModel)]="model.empLevelMin">
                        <option [value]="undefined" class="color-valyrianSteel"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Select_Placeholder">Select</span></option>
                        <option *ngFor="let groupType of groupTypes?.emp" [ngValue]="groupType.GroupLevel">{{groupType.GroupTypeName}}</option>
                    </select>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-5">
                    <label class="form-control-label body-2 mb-0" for="selectRecLevelMin" cvLocalizedText langSection="Pipeline_Configuration" langKey="Recording_Hierarchy_Label">Recording Hierarchy</label><br/>
                    <div class="caption color-valyrianSteel" cvLocalizedText langSection="Pipeline_Configuration" langKey="Hierarchy_Hint">Select the lowest level this metric applies to.</div>
                </div>
            </div>
            <div class="row">
                <div class="col-5">
                    <select class="form-control" id="selectRecLevelMin" [class]="{'color-valyrianSteel': model.recLevelMin == null}" [(ngModel)]="model.recLevelMin">
                        <option [value]="undefined" class="color-valyrianSteel"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Select_Placeholder">Select</span></option>
                        <option *ngFor="let groupType of groupTypes?.rec" [ngValue]="groupType.GroupLevel">{{groupType.GroupTypeName}}</option>
                    </select>
                </div>
            </div>
            <!-- Category -->
            <div class="row mt-4">
                <div class="col-5">
                    <label class="form-control-label body-2" for="metricCategory" cvLocalizedText langSection="Pipeline_Configuration" langKey="Category">Category</label><span title="Required" cvLocalizedAttrs="title" attrLangSection="Pipeline_Configuration" attrLangKey="Required" class="required body-2 color-redRyder">*</span>
                </div>
            </div>
            <div class="row">
                <div class="col-5">
                    <input type="text" id="metricCategory" class="form-control w-100" [(ngModel)]="model.category" maxlength="50" list="existingMetricCategories"/>
                    <datalist id="existingMetricCategories">
                        <option *ngFor="let category of metricCategories" [value]="category">
                    </datalist>
                </div>
            </div>
            <!-- Objective Direction -->
            <div class="row mt-4">
                <div class="col">
                    <fieldset>
                        <legend class="form-control-label body-2 mb-2">
                            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Objective_Direction">Objective Direction</span>
                            <div class="d-inline fill-valyrianSteel fill-hover-whaleTail"
                            ngbPopover="Indicates the direction in which the metrics objective will be obtained."
                            placement="bottom auto" triggers="mouseenter:mouseleave" style="width: 16px; height: 16px;">
                            <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/support.svg#support"></use></svg>
                        </div></legend>
                        <div class="d-flex">
                            <div class="form-check pr-3">
                                <input type="radio" class="form-check-input" id="objectiveDirectionUp" name="objectiveDirection" [value]="1" [(ngModel)]="model.direction"/>
                                <label class="form-check-label" for="objectiveDirectionUp" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Direction_Up">Up</label>
                            </div>
                            <div class="form-check">
                                <input type="radio" class="form-check-input" id="objectiveDirectionDown" name="objectiveDirection" [value]="0" [(ngModel)]="model.direction"/>
                                <label class="form-check-label" for="objectiveDirectionDown" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Direction_Down">Down</label>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
            <!-- Aggregation -->
            <div class="row mt-4">
                <div class="col-3">
                    <label class="form-control-label body-2" for="selectAggregationType" cvLocalizedText langSection="Pipeline_Configuration" langKey="Aggregation">Aggregation</label><span title="Required" cvLocalizedAttrs="title" attrLangSection="Pipeline_Configuration" attrLangKey="Required" class="required body-2 color-redRyder">*</span>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <select class="form-control" id="selectAggregationType" [class]="{'color-valyrianSteel': model.aggregationType == null}" [(ngModel)]="model.aggregationType">
                        <option [value]="undefined" class="color-valyrianSteel"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Select_Placeholder">Select</span></option>
                        <option [ngValue]="0"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Sum">Sum</span></option>
                        <!-- Min shouldn't be settable, but if an existing metric definition exists with it, show it: -->
                        <option [ngValue]="1" *ngIf="shouldShowAggregationMin()"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Min">Min</span></option>
                        <option [ngValue]="2"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Max">Max</span></option>
                    </select>
                </div>
            </div>
            <div class="row mt-4">
                <!-- Numeric Type/Format Type Label -->
                <div class="col-3">
                    <div>
                        <label for="selectFormatType" class="form-control-label body-2" cvLocalizedText langSection="Pipeline_Configuration" langKey="Format_Type">Format Type</label><span title="Required" cvLocalizedAttrs="title" attrLangSection="Pipeline_Configuration" attrLangKey="Required" class="required body-2 color-redRyder">*</span>
                    </div>
                </div>
                <!-- Time Format Label -->
                <div class="col-3" *ngIf="model.numericType == 3">
                    <div>
                        <label for="selectTimeFormat" class="form-control-label body-2" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Time_Format">Time Format</label><span title="Required" cvLocalizedAttrs="title" attrLangSection="Pipeline_Configuration" attrLangKey="Required" class="required body-2 color-redRyder">*</span>
                    </div>
                </div>
                <!-- Currency Format Label -->
                <div class="col-3" *ngIf="model.numericType == 0">
                    <div>
                        <label for="selectCurrencyFormat" class="form-control-label body-2" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Currency_Format">Currency Format</label><span title="Required" cvLocalizedAttrs="title" attrLangSection="Pipeline_Configuration" attrLangKey="Required" class="required body-2 color-redRyder">*</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- Numeric Type/Metric Type Select-->
                <div class="col-3">
                    <!-- The order of these options matches the design, not the enum -->
                    <select class="form-control" id="selectFormatType" [class]="{'color-valyrianSteel': model.numericType == null}" [ngModel]="model.numericType" (ngModelChange)="model.numericType = $event; model.timeFormat = 1; model.currencyFormat = currencies.USD;">
                        <option [value]="undefined" class="color-valyrianSteel"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Select_Placeholder">Select</span></option>
                        <option [ngValue]="3"><span cvLocalizedText langSection="Metrics" langKey="Time">Time</span></option>
                        <option [ngValue]="0"><span cvLocalizedText langSection="Metrics" langKey="Currency">Currency</span></option>
                        <option [ngValue]="1"><span cvLocalizedText langSection="Metrics" langKey="Number">Number</span></option>
                        <option [ngValue]="2"><span cvLocalizedText langSection="Metrics" langKey="Percent">Percent</span></option>
                    </select>
                </div>
                <!-- Time Format Select -->
                <div class="col-3" *ngIf="model.numericType == 3">
                    <select class="form-control" id="selectTimeFormat" [class]="{'color-valyrianSteel': model.timeFormat == null}" [(ngModel)]="model.timeFormat">
                        <option [value]="undefined" class="color-valyrianSteel"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Select_Placeholder">Select</span></option>
                        <option [ngValue]="1"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Seconds">Seconds</span></option>
                        <option [ngValue]="2"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Minutes">Minutes</span></option>
                        <option [ngValue]="3"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Hours">Hours</span></option>
                        <option [ngValue]="4">HH:MM:SS</option>
                    </select>
                </div>
                <!-- Currency Format Select -->
                <div class="col-5" *ngIf="model.numericType == 0">
                    <select class="form-control" id="selectCurrencyFormat" [class]="{'color-valyrianSteel': model.currencyFormat == null}" [(ngModel)]="model.currencyFormat">
                        <option [value]="undefined" class="color-valyrianSteel"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Select_Placeholder">Select</span></option>
                        <option *ngFor="let currency of currencies | keyvalue: sortCurrency" [ngValue]="currency.value">
                            <span>{{getCurrencySymbol(currency.key) + " ("+currency.key+") - "}}</span>
                            <span cvLocalizedText langSection="Pipeline_Configuration" [langKey]="currency.key">{{currency.value}}</span></option>
                    </select>
                </div>
            </div>
            <!-- Components -->
            <div class="row mt-5">
                <div class="col">
                    <div class="font-size-18 mb-0 lato-bold" cvLocalizedText langSection="Pipeline_Configuration" langKey="Components">Components</div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-5">
                    <label class="form-control-label body-2 mb-0" for="selectMetricComponent" cvLocalizedText langSection="Metrics" langKey="Component_Type">Component Type</label><span title="Required" cvLocalizedAttrs="title" attrLangSection="Pipeline_Configuration" attrLangKey="Required" class="required body-2 color-redRyder">*</span><br/>
                    <div class="caption color-valyrianSteel" cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Component_Type_Hint">Sets the type for all components in this metric</div>
                </div>
            </div>
            <div class="row">
                <div class="col-5">
                    <select class="form-control" id="selectMetricComponent" [class]="{'color-valyrianSteel': model.componentType == null}" [(ngModel)]="model.componentType">
                        <option [value]="undefined" class="color-valyrianSteel"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Select_Placeholder">Select</span></option>
                        <option [ngValue]="0"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Component_Type_Standard">Standard Metric</span></option>
                        <option [ngValue]="1"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Component_Type_Calculated">Calculated Metric</span></option>
                        <option [ngValue]="2"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Component_Type_Snapshot">Snapshot Metric</span></option>
                    </select>
                </div>
            </div>
            <div class="row mt-3" [ngSwitch]="model.componentType">
                <!-- Standard Metric -->
                <div class="col" *ngSwitchCase="0">
                    <button type="button" class="btn btn-sm btn-primary btn-icon" (click)="addComponentClicked()" [disabled]="isBlocked"
                        title="Add Component" cvLocalizedAttrs="title" attrLangSection="Metrics" attrLangKey="Add_Component">
                        <svg><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                        <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Add_Component">Component</span>
                    </button>
                    <div class="metricComponents mt-2 d-flex flex-column">
                        <metric-component-preview *ngFor="let component of model.standardComponents" [component]="component" [metricType]="MetricTypes.Standard" [editable]="true" (onDelete)="deleteStandardComponent($event)" (onEdit)="editStandardComponent(component)"></metric-component-preview>
                    </div>
                </div>
                <!-- Calculated Metric -->
                <div class="col" *ngSwitchCase="1">
                    <metric-formula [initialFormula]="model.metricFormula" [rootMetricID]="model.metricID" (formulaChange)="formulaChanged($event)"></metric-formula>
                </div>
                <!-- Snapshot Metric -->
                <div class="col" *ngSwitchCase="2">
                    <button type="button" class="btn btn-sm btn-primary btn-icon" (click)="addComponentClicked()" [disabled]="isBlocked || model.snapshotComponents.length > 0"
                        [attr.title]="getAddSnapshotComponentButtonTitle()">
                        <svg><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                        <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Add_Component">Component</span>
                    </button>
                    <div class="metricComponents mt-2 d-flex flex-column">
                        <metric-component-preview *ngFor="let component of model.snapshotComponents" [component]="component" [metricType]="MetricTypes.RealTime" [editable]="true" (onDelete)="deleteSnapshotComponent($event)" (onEdit)="editSnapshotComponent(component)"></metric-component-preview>
                    </div>
                </div>
            </div>
            <!-- Assignments -->
            <div class="row mt-5">
                <div class="col">
                    <div class="font-size-18 mb-0 lato-bold" cvLocalizedText langSection="Metrics" langKey="Assignments">Assignments</div>
                    <div class="caption color-valyrianSteel"><span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Assignments_Hint">By default this is assigned to all</span></div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <button type="button" class="btn btn-sm btn-secondary" [disabled]="!assignmentGroupsLoaded" (click)="editAssignmentsClicked()">
                        <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metric_Edit_Assignments">Edit Assignments</span>
                    </button>
                    <div class="d-inline-block position-relative" style="width: 32px; height: 32px;" *ngIf="!assignmentGroupsLoaded">
                        <cv-loader class="d-block" [overlay]="false" size="small"></cv-loader>
                    </div>
                    <cv-angular-assign-tool type="metricDefinition" headerText="Metric Definition Assignments" [singleType]="true"
                        [(showPopup)]="assignToolOpened" [retainSelected]="true" showTypes="rec" [dataTransfer]="assignToolData"
                        (dataTransferChange)="onAssignmentsChanged($event)" [singleAdd]="true" [showAll]="true">
                    </cv-angular-assign-tool>
                </div>
            </div>
            <!-- Show assigned groups: -->
            <div class="row mt-2 assignments-row">
                <div class="col">
                    <div class="mt-2 font-weight-bold" *ngIf="assignToolData.rec.length > 0">{{groupTypes?.rec?.[assignToolData?.coreAssignAtLevel]?.GroupTypeName}}:</div>
                    <div class="d-flex flex-wrap" *ngIf="assignToolData.rec.length > 0">
                        <div style="width: 33%" *ngFor="let recGroup of assignToolData.rec; trackBy: trackAssignToolDataRec">
                            - {{recGroup.GroupName}}
                        </div>
                    </div>
                    <div *ngIf="!assignToolData.rec.length">
                        - <span cvLocalizedText langSection="Common" langKey="All">All</span>
                    </div>
                </div>
            </div>
            <!-- Cancel and Save Buttons -->
            <div class="row mt-5 mb-3">
                <div class="col d-flex justify-content-end">
                    <button type="button" class="btn btn-text mr-2" (click)="cancelClicked()" [disabled]="isBlocked">
                        <span cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</span>
                    </button>
                    <button type="button" class="btn btn-primary" (click)="saveClicked()" [disabled]="isBlocked || !isMetricDefinitionValid()">
                        <span cvLocalizedText langSection="Common" langKey="Save_Button">Save</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
